import CompilationsApi from '@/frontend/api/compilations';
import setMetas from '@/frontend/functions/setMetas';
export default {
  name: "CompilationsPage",

  data() {
    return {
      compilations: [],
      PaginationLinks: {},
      PaginationMeta: {
        currentPage: 1,
        pageCount: 1
      },
      search: ''
    };
  },

  watch: {
    search() {
      this.changePage(1);
    }

  },
  methods: {
    requestCompilations() {
      let requestParams = {
        fields: ['id', 'name', 'description', 'thumbWithPath'].join(','),
        'per-page': 12,
        page: this.PaginationMeta.currentPage
      };
      this.search && (requestParams['filter[or][][name][like]'] = this.search);
      this.search && (requestParams['filter[or][][description][like]'] = this.search);
      CompilationsApi.get(requestParams).then(response => {
        this.compilations = response.items;
        this.PaginationLinks = response._links;
        this.PaginationMeta = response._meta;
      });
    },

    changePage(number) {
      if (number < 1 || this.PaginationMeta.pageCount && number > this.PaginationMeta.pageCount) return;
      this.PaginationMeta.currentPage = number;
      this.requestCompilations();
      window.scrollTo(0, 0);
    }

  },

  created() {
    setMetas('compilations');
    this.requestCompilations();
  }

};